(function() {
  console.log("🍃 Flora: Initialisierung (Stabil + Sichtbarkeits-Fix)...");

  // 1. Styles (Extrem hoher Z-Index und sichere Position)
  const style = document.createElement('style');
  style.innerHTML = `
    @import url('https://fonts.googleapis.com/css2?family=Barlow+Condensed:wght@400;600;700&display=swap');
    :root { --flo-green: #01450F; --flo-text: #2D2926; --flo-font: 'Barlow Condensed', sans-serif; }
    
    /* Wir rücken das Widget 120px vom rechten Rand weg, damit es neben GTM steht */
   #flo-teaser {
      position: fixed !important; 
      bottom: 40px !important;
      left: 20px !important; 
      right: auto !important; 
      width: 280px !important; 
      background: rgba(255, 255, 255, 0.6) !important; 
      backdrop-filter: blur(12px) !important; 
      -webkit-backdrop-filter: blur(12px) !important; 
      border: none !important;
      border-radius: 20px !important;
      box-shadow: 0 8px 32px rgba(0,0,0,0.1) !important;
      padding: 15px !important; 
      z-index: 2147483647 !important;
      font-family: var(--flo-font);
      cursor: pointer;
      display: block;
    }

    #flo-auth { 
      position: fixed !important; 
      bottom: 40px !important;
      left: 20px !important;
      right: auto !important;
      width: 320px !important; 
      background: white !important; 
      border-radius: 20px !important;
      box-shadow: 0 15px 40px rgba(0,0,0,0.4) !important;
      z-index: 2147483647 !important; 
      font-family: var(--flo-font);
      display: none; 
      overflow: hidden; 
      border: 1px solid #eee;
    }

    .flo-header { background: var(--flo-green); color: white; padding: 15px; font-weight: 600; font-size: 20px; text-align: center; text-transform: uppercase; }
    .flo-body { padding: 20px; display: flex; flex-direction: column; gap: 12px; }
    .flo-input { padding: 10px; border: 1px solid #ddd; border-radius: 8px; font-size: 16px; color: #000; }
    .flo-btn { background: var(--flo-green); color: white; border: none; padding: 12px; border-radius: 25px; cursor: pointer; font-size: 18px; font-weight: 600; }

    /* n8n Chat-Fenster Fix */
    .n8n-chat-widget { z-index: 2147483647 !important; }
    .n8n-chat-widget-window { z-index: 2147483647 !important; bottom: 40px !important; left: 20px !important; right: auto !important; }

/* Pre-Teaser Button – nur Mobile */
#flo-pre-teaser {
  display: none;
}
 
@media (max-width: 768px) {
 
  /* Haupt-Teaser auf Mobile verstecken – wird durch Pre-Teaser ersetzt */
  #flo-teaser {
    display: none !important;
  }
 
  /* Auth-Fenster auf Mobile */
  #flo-auth {
    right: 10px !important;
    left: 10px !important;
    width: calc(100% - 20px) !important;
    bottom: 100px !important;
  }
 
  /* Chat-Fenster auf Mobile */
  .n8n-chat-widget-window {
    right: 10px !important;
    width: calc(100% - 20px) !important;
    bottom: 100px !important;
  }
 
  /* Pre-Teaser Button – sichtbar auf Mobile */
  #flo-pre-teaser {
    display: flex !important;
    position: fixed !important;
    bottom: 90px !important;        /* Hoch genug um CTAs nicht zu stören */
    right: 20px !important;
    left: auto !important;
    width: 62px !important;
    height: 62px !important;
    background: #01450F !important;
    border-radius: 50% !important;
    align-items: center !important;
    justify-content: center !important;
    font-size: 28px !important;
    cursor: pointer !important;
    z-index: 2147483647 !important;
    border: none !important;
    box-shadow: 0 4px 16px rgba(1,69,15,0.35) !important;
    outline: none !important;
  }
 
  /* Puls-Ring Animation */
  #flo-pre-teaser::before {
    content: '';
    position: absolute;
    width: 100%;
    height: 100%;
    border-radius: 50%;
    background: #01450F;
    opacity: 0.4;
    animation: flo-pulse 8s ease-out infinite;
  }
 
  @keyframes flo-pulse {
    0%   { transform: scale(1);   opacity: 0.4; }
    15%  { transform: scale(1.5); opacity: 0;   }
    100% { transform: scale(1.5); opacity: 0;   }
  }
}
  `;
  document.head.appendChild(style);

  // 2. n8n Bibliothek laden (Klassischer Weg wie in deinem alten Code)


// 3. Launch Funktion - API VERSION (Sicherer Fix gegen leere Fenster)
async function launchFlora(name, email) {
  const teaser = document.getElementById('flo-teaser');
  const auth = document.getElementById('flo-auth');
  
if (!document.getElementById('flo-chat-window')) {
    const chatWin = document.createElement('div');
    chatWin.id = 'flo-chat-window';
    const isMobile = window.innerWidth <= 768;
    chatWin.style.cssText = isMobile
      ? 'position:fixed;bottom:0;left:0;right:0;top:0;width:100%;height:' + window.innerHeight + 'px;background:rgba(255,255,255,0.85);border-radius:0;box-shadow:none;z-index:2147483647;display:flex;flex-direction:column;overflow:hidden;border:none;font-family:var(--flo-font);'
      : 'position:fixed;bottom:30px;right:30px;width:350px;height:550px;background:rgba(255,255,255,0.85);border-radius:20px;box-shadow:0 15px 50px rgba(0,0,0,0.3);z-index:2147483647;display:flex;flex-direction:column;overflow:hidden;border:1px solid #eee;font-family:var(--flo-font);';
    
        if (isMobile) {
      document.body.style.overflow = 'hidden';
      // Tastatur-Fix: Fenster passt sich an wenn Tastatur aufgeht
      window.addEventListener('resize', () => {
        const chatWindow = document.getElementById('flo-chat-window');
        if (chatWindow && chatWindow.style.display !== 'none') {
          chatWindow.style.height = window.innerHeight + 'px';
        }
      });
    }
const isReturning = localStorage.getItem('flo_returning_' + email);
const welcomeHTML = !isReturning ? `<div style="background:#e8f5e9;padding:12px;border-radius:15px 15px 15px 0;align-self:flex-start;color:#01450F;max-width:85%;">Wie kann ich dir helfen? 🍃</div>` : '';
localStorage.setItem('flo_returning_' + email, 'true');
    chatWin.innerHTML = `
      <div class="flo-header" style="display:flex;justify-content:space-between;align-items:center;background:#01450F;color:white;padding:15px;">
        <span>Flora 🍃 - Living Soil Agentin</span>
        <button onclick="document.getElementById('flo-chat-window').style.display='none';document.body.style.overflow='';if(window.innerWidth<=768){document.getElementById('flo-pre-teaser').style.display='flex';}else{document.getElementById('flo-teaser').style.display='block';}" style="background:none;border:none;color:white;cursor:pointer;font-size:20px;">✕</button>
      </div>
      <div id="flo-history" style="flex:1;padding:15px;overflow-y:auto;background:#f9f9f9;display:flex;flex-direction:column;gap:12px;">
        ${welcomeHTML} </div>
      <div style="padding:15px;border-top:1px solid #eee;display:flex;gap:8px;background:white;">
        <input type="text" id="flo-input" style="flex:1;border:1px solid #ddd;padding:10px;border-radius:20px;outline:none;font-size:16px;" placeholder="Deine Frage...">
        <button id="flo-send" style="background:#01450F;color:white;border:none;width:40px;height:40px;border-radius:50%;cursor:pointer;display:flex;align-items:center;justify-content:center;">➔</button>
      </div>
    `;
    document.body.appendChild(chatWin);

    const input = document.getElementById('flo-input');
    const history = document.getElementById('flo-history');

       const send = async () => {
      const text = input.value.trim();
      if(!text) return;
      history.innerHTML += `<div style="background:#01450F;padding:12px;border-radius:15px 15px 0 15px;align-self:flex-end;color:white;max-width:85%;">${text}</div>`;
      input.value = '';
      history.scrollTop = history.scrollHeight;
      
      const loading = document.createElement('div');
      loading.innerHTML = `<span style="font-size:12px;color:#888;">Flora denkt nach... 🍃</span>`;
      history.appendChild(loading);

      try {
        const res = await fetch('https://florganics.app.n8n.cloud/webhook/b85e377a-d05b-4dac-99f2-a2b6b6278e40'
, {
          method: 'POST',
          headers: {'Content-Type': 'application/json'},
          body: JSON.stringify({ chatInput: text, sessionId: email, email: email, name: name })
        });
        const data = await res.json();
        loading.remove();
        const response = Array.isArray(data) ? data[0] : data;
        let reply = response?.output || response?.bot_response || '';
        reply = reply.replace(/\[([^\]]+)\]\((https?:\/\/[^\)]+)\)/g, '<a href="$2" target="_blank" style="color:#01450F;font-weight:bold;text-decoration:underline;">$1</a>');
        reply = reply.replace(/\*\*([^*]+)\*\*/g, '<strong>$1</strong>');
        reply = reply.replace(/\n/g, '<br>');
        history.innerHTML += `<div style="background:#e8f5e9;padding:12px;border-radius:15px 15px 15px 0;align-self:flex-start;color:#01450F;max-width:85%;">${reply}</div>`;
        history.scrollTop = history.scrollHeight;
      } catch (err) {
        loading.innerText = "Fehler: Flora ist gerade offline. 🍃";
      }
    };

    document.getElementById('flo-send').onclick = send;
    input.onkeypress = (e) => { if(e.key === 'Enter') send(); };
  }
  teaser.style.display = 'none';
  auth.style.display = 'none';
  document.getElementById('flo-chat-window').style.display = 'flex';
}

// 4. Widget sofort einbauen
const teaser = document.createElement('div');
teaser.id = 'flo-teaser';
teaser.innerHTML = `
<div style="position:relative;">
  <button onclick="event.stopPropagation();document.getElementById('flo-teaser').style.display='none';" style="position:absolute;top:-8px;right:-8px;background:#01450F;border:none;color:white;cursor:pointer;font-size:14px;width:22px;height:22px;border-radius:50%;display:flex;align-items:center;justify-content:center;line-height:1;">✕</button>
  <div style="display:flex;align-items:center;gap:10px;margin-bottom:10px;">
    <div style="width:45px;height:45px;background:#f0f0f0;border-radius:50%;display:flex;align-items:center;justify-content:center;font-size:22px;border:2px solid #01450F;">🍃</div>
    <div style="font-weight:700;font-size:17px;color:#2D2926;line-height:1.2;">Flora - Living Soil Agentin<br><span style="font-weight:400;font-size:13px;">Jetzt online</span></div>
  </div>
  <button class="flo-btn" style="width:100%;padding:8px;font-size:15px;text-align:center;">Chat starten</button>
  </div>
`;
document.body.appendChild(teaser);

// ✅ OPTIMIERT: Klick auf den ganzen Teaser erlauben
teaser.onclick = (e) => {
  e.stopPropagation(); // Verhindert Probleme mit anderen Klicks auf der Seite
  
  const savedEmail = localStorage.getItem('flo_chat_email');
  const savedName = localStorage.getItem('flo_chat_name');
  
  if (savedEmail && savedName) {
    teaser.style.display = 'none';
    launchFlora(savedName, savedEmail);
  } else {
    teaser.style.display = 'none';
    document.getElementById('flo-auth').style.display = 'block';
  }
};

  const auth = document.createElement('div');
    auth.id = 'flo-auth';
  auth.innerHTML = `
    <div class="flo-header" style="display:flex; justify-content:space-between; align-items:center; padding: 15px;">
      <span>Beratung starten</span>
      <button 
        onclick="document.getElementById('flo-auth').style.display='none'; document.getElementById('flo-teaser').style.display='block';" 
        style="background:none; border:none; color:white; cursor:pointer; font-size:24px; line-height:1; padding: 0 5px;">✕</button>
    </div>
    <div class="flo-body">
      <input type="text" id="flo-name" class="flo-input" placeholder="DEIN NAME">
      <input type="email" id="flo-email" class="flo-input" placeholder="DEINE E-MAIL">
      <button id="flo-final-start" class="flo-btn" style="width:100%;text-align:center;">JETZT STARTEN</button>
      <button id="flo-skip" style="background:none;border:none;color:#01450F;cursor:pointer;font-size:14px;text-decoration:underline;width:100%;text-align:center;padding:8px 0;margin-top:4px;">Ohne E-Mail starten →</button>
      <p style="font-size:11px;color:#888;text-align:center;margin-top:8px;">Mit dem Start akzeptierst du unsere <a href="https://www.florganics.de/policies/privacy-policy" target="_blank" style="color:#01450F;">Datenschutzerklärung</a></p>
    </div>
  `;
  document.body.appendChild(auth);

  document.getElementById('flo-final-start').onclick = (e) => {
  e.stopPropagation();
  e.preventDefault();
  
  const n = document.getElementById('flo-name').value.trim();
  const em = document.getElementById('flo-email').value.trim();
  
  if (n && em) {
    localStorage.setItem('flo_chat_email', em);
    localStorage.setItem('flo_chat_name', n);
    auth.style.display = 'none';
    launchFlora(n, em);
  }
};

document.getElementById('flo-skip').onclick = (e) => {
  e.stopPropagation();
  let sid = localStorage.getItem('flo_session_id');
  if (!sid) {
    sid = 'guest_' + Math.random().toString(36).substr(2, 9);
    localStorage.setItem('flo_session_id', sid);
  }
  auth.style.display = 'none';
  launchFlora('Gast', sid);
};

  // Pre-Teaser Button erstellen
  const preTeaser = document.createElement('button');
  preTeaser.id = 'flo-pre-teaser';
  preTeaser.innerHTML = '🍃';
  preTeaser.setAttribute('aria-label', 'Flora Chat öffnen');
  document.body.appendChild(preTeaser);

  // Klick: Pre-Teaser verschwindet, Teaser erscheint
  preTeaser.onclick = () => {
    preTeaser.style.setProperty('display', 'none', 'important');
    const teaser = document.getElementById('flo-teaser');
    teaser.style.cssText += `
      display: block !important;
      opacity: 0;
      transform: translateY(10px);
      transition: opacity 0.25s ease, transform 0.25s ease;
      right: 10px !important;
      left: auto !important;
      width: 260px !important;
      bottom: 100px !important;
    `;
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        teaser.style.opacity = '1';
        teaser.style.transform = 'translateY(0)';
      });
    });
    // X-Button im Teaser → Pre-Teaser zurück
    const closeBtn = teaser.querySelector('button');
    if (closeBtn) {
      closeBtn.onclick = (e) => {
        e.stopPropagation();
        teaser.style.display = 'none';
        if (window.innerWidth <= 768) {
          preTeaser.style.display = 'flex';
        }
      };
    }
  };
})()